import '@/lib/theme';
import { StrictMode, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { App } from './app/App';
import { useSession } from './store/session';
import { useLanguage } from './lib/i18n';
import { registerServiceWorker } from './lib/pwa';
// Tipografías del sistema de diseño, servidas desde la propia web.
import '@fontsource-variable/inter';
import '@fontsource-variable/space-grotesk';
import '@fontsource-variable/jetbrains-mono';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // El ajedrez cambia rápido: preferimos datos frescos al volver a la
      // pestaña, pero sin reintentos agresivos que castiguen al servidor.
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
});

function Root() {
  const bootstrap = useSession((s) => s.bootstrap);
  // Al cambiar de idioma se vuelve a montar la aplicación (sin recargar la
  // página ni cambiar de ruta) para que todo se pinte con el nuevo.
  const language = useLanguage();

  useEffect(() => {
    void bootstrap();
  }, [bootstrap]);

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App key={language} />
      </BrowserRouter>
    </QueryClientProvider>
  );
}

registerServiceWorker();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
